<kendo-tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab
    *ngFor="let tab of tabs"
    [title]="tab.name"
    [selected]="tab.selected"
  >
    <ng-template kendoTabContent>
      <router-outlet></router-outlet>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
